<template>
	<LottieAnimation :ref="settings.defaultOptions.name" :animationData="settings.defaultOptions.animationData" :loop="settings.defaultOptions.loop" :autoPlay="settings.defaultOptions.autoplay" :speed="settings.defaultOptions.animationSpeed" :class="settings.class" :style="settings.styles" />
</template>

<script>
	import _ from 'lodash'
	import { LottieAnimation } from "lottie-web-vue"

	export default {
		props: {
			options: { type: Object, default: () => { } },
		},
		components: {
			LottieAnimation
		},
		data() { // for more info https://github.com/garbit/lottie-web-vue
			return {
				settings: this.getDefaultOptions(),
				lottieAnimation: null
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			this.lottieAnimation = this.$refs[this.settings.defaultOptions.name]
		},
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					this.settings = _.merge(this.settings, val)
				},
			}
		},
		methods: {
			getDefaultOptions() {
				let id = this.idGenerator(5)
				return {
					id: id,
					class: '',
					styles: {
						width: '400px',
						height: '400px',
					},
					quality: 'high', // high / medium / low,
					direction: 1, // 1 normal direction , -1 reverese direction
					defaultOptions: {
						animationSpeed: 1,
						animationData: '',
						autoplay: true, // true, false
						loop: true, // true / false / number,
						name: `lottie-animation-${id}`,
						container: '',
					},
				}
			},
			stop() {
				this.lottieAnimation.stop()
			},
			play() {
				this.lottieAnimation.play()
			},
			pause() {
				this.lottieAnimation.pause()
			},
			setDirection(direction) {
				this.lottieAnimation.setDirection(direction)
			},
			setSpeed(speed) {
				this.lottieAnimation.setSpeed(speed)
			},
			destroy() {
				this.lottieAnimation.destroy()
			},
		}
	}
</script>
